<template lang="pug">
  v-layout(align-center justify-center row fill-height)
    v-flex(style="text-align: center;padding: 0em 1em;")
      span(style="color: #0855C4;font-size: 14px;") {{mensaje || '¡Esto es todo lo que lograste hasta hoy, sigue así!'}}
    v-flex
      v-img
        img(style="float: left;height:110px;width:110px" :src="icon")
</template>

<script>
export default {
  props: [
    "mensaje",
    "icon",
  ]
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/generic/MensajeTextIconRow.vue